// AUDITORIA-CLINICA-REDISENO (FASE 1 · Estado 4) -- las secciones que el
// médico no registró NO son tarjetas ni checkboxes deshabilitados: son una
// fila de 42px dentro de un único bloque agrupado. En el modal actual 5 de 7
// secciones aparecían como checkbox deshabilitado con el texto "— sin registro
// en esta atención para corregir": mitad de la interfaz era ruido.
//
// Sin botón "Solicitar al médico": no corresponde a ninguna acción existente
// (la tabla `notificaciones` está en el schema pero ningún código backend la
// usa, ver FASE 0 §6). Se deja informativo antes que ofrecer un botón que no
// hace nada.
//
// COMPLETAR-SECCION-VACIA: las secciones que el backend SÍ sabe crear ofrecen
// "Completar" (ver SECCIONES_COMPLETABLES). La única que queda informativa es
// `recetas`: crear una prescripción desde cero exigiría atribuírsela a un
// médico que nunca la emitió, que es un bloqueo estructural, no una falta de
// implementación.
import { SECCIONES_COMPLETABLES } from "../../../utils/auditoriaCorreccion";

function AtencionSinRegistroBloque({ secciones, onCompletar }) {
    if (!secciones || secciones.length === 0) return null;
    return (
        <div className="ac-sinregistro" data-testid="ac-sinregistro">
            {secciones.map((seccion) => (
                <div className="ac-sinregistro__fila" key={seccion.id} data-testid={`ac-sinregistro-${seccion.id}`}>
                    <span className="ac-sinregistro__nombre">{seccion.label}</span>
                    <span>El médico no registró esta sección</span>
                    {onCompletar && SECCIONES_COMPLETABLES.includes(seccion.id) && (
                        <button
                            type="button"
                            className="ac-sinregistro__completar"
                            onClick={() => onCompletar(seccion.id)}
                            data-testid={`ac-completar-${seccion.id}`}
                        >
                            Completar
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}

export default AtencionSinRegistroBloque;
